import { AirshipEventsTableData } from "./AirshipEventsTable.types";

/**
 * Return true if any item in `data` contains a `properies` field
 * @param data Events table data
 * @returns {boolean}
 */
export const showPropertiesColumn = (data?: AirshipEventsTableData[]) =>
  !!data?.length && !!data.find((item) => item.properties);
